module.exports = __webpack_public_path__ + "img/infinity5.5bc65175.jpg";